import React, { useState } from 'react';
import { Nav, Collapse } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const staticDataPaths = [ '/cities', '/clients', '/sites', 'shifts', '/schedules', '/checkpoints'];
const transactionsPaths = [ '/patrol-logs', '/duty-logs', '/incident-reports', '/operational-reports'  ];
const administrationPaths = [ '/users', '/database-administration', '/settings', '/reports'];

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openStaticData, setOpenStaticData] = useState(false);
  const [openAdministration, setOpenAdministration] = useState(false);
  const [openTransactions, setOpenTransactions] = useState(false);

  const handleLinkClick = (path) => {
    navigate(path);
  }

  const isActive = (paths) => paths.includes(location.pathname);

  return (
    <div id='sidebar' className="d-md-block sidebar">
      <Nav className='flex-column'>
        <Nav.Item>
          <Nav.Link as={Link} to='/' active={location.pathname === '/'}>
            Dashboard
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link onClick={() => setOpenStaticData(!openStaticData)} className={`dropdown-toggle ${openStaticData ? "open" : ""}`}>
            Static Data
          </Nav.Link>
          <Collapse in={openStaticData}>
            <div>
              <Nav className="flex-column">
                <Nav.Link as={Link} to='/cities' active={location.pathname === '/cities'}>
                  Cities
                </Nav.Link>
                <Nav.Link as={Link} to='/clients' active={location.pathname === '/clients'}>
                  Clients
                </Nav.Link>
                <Nav.Link as={Link} to='/sites' active={location.pathname === '/sites'}>
                  Sites
                </Nav.Link>
                <Nav.Link as={Link} to='/checkpoints' active={location.pathname === '/checkpoints'}>
                  Checkpoints
                </Nav.Link>
                <Nav.Link as={Link} to='/shifts' active={location.pathname === '/shifts'}>
                  Shifts
                </Nav.Link>
                <Nav.Link as={Link} to='/schedules' active={location.pathname === '/schedules'}>
                  Schedules
                </Nav.Link>
                <Nav.Link as={Link} to='/reports' active={location.pathname === '/reports'}>
                  Reports
                </Nav.Link>
              </Nav>
            </div>
          </Collapse>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link onClick={() => setOpenTransactions(!openTransactions)} className={`dropdown-toggle ${openTransactions ? 'open' : ""}`}>
            Transactions
          </Nav.Link>
          <Collapse in={openTransactions}>
            <div>
              <Nav className='flex-column'>
                <Nav.Link as={Link} to='/duty-logs' active={location.pathname === '/duty-logs'}>
                  Duty Logs
                </Nav.Link>
                <Nav.Link as={Link} to='/patrol-logs' active={location.pathname === '/patrol-logs'}>
                  Patrol Logs
                </Nav.Link>
                <Nav.Link as={Link} to='/incident-reports' active={location.pathname === '/incident-reports'}>
                  Incident Reports
                </Nav.Link>
                <Nav.Link as={Link} to='/operational-reports' active={location.pathname === '/operational-reports'}>
                  Operational Reports
                </Nav.Link>
              </Nav>
            </div>
          </Collapse>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link onClick={() => setOpenAdministration(!openAdministration)} className={`dropdown-toggle ${openAdministration ? "open" : ""}`}>
            Administration
          </Nav.Link>
          <Collapse in={openAdministration}>
            <div>
              <Nav className="flex-column">
                <Nav.Link as={Link} to='/users' active={location.pathname === '/users'}>
                  Users
                </Nav.Link>
                <Nav.Link as={Link} to='/database-administration' active={location.pathname === '/database-administration'}>
                  Database Administration
                </Nav.Link>
                <Nav.Link as={Link} to='/settings' active={location.pathname === '/settings'}>
                  Settings
                </Nav.Link>
                <Nav.Link as={Link} to='/reports' active={location.pathname === '/reports'}>
                  Reports Management
                </Nav.Link>
              </Nav>
            </div>
          </Collapse>
        </Nav.Item>
      </Nav>
    </div>
  );
};

export default Sidebar;